import GenericBffClient from 'Utils/httpClients/GenericBffClient';
import { DOMAIN, LoggerFactory } from 'Services/Logger';
import { AuthorizePhoneChangeResponse, ValidatePhoneChangeResponse } from 'Models/ConsumerEnablementBff/PhoneChange';
import { mapToAurora } from 'Utils/mapToAurora';
import {
  SendNIPResponse, SendOTPPayload, VerifyOTPPayload,
} from 'Models/ConsumerEnablementBff';

const logger = LoggerFactory.getLogger(DOMAIN.PROFILE);

export class ConsumerEnablementBffV3 extends GenericBffClient {
  constructor() {
    super('CONSUMER_ENABLEMENT_BFF_API', '/api/v3/', { logger });
  }

  /**
   * Validates if the user can change the phone
   *
   * @returns The outcome of the request
   */
  async validatePhoneChange() {
    return this.get<ValidatePhoneChangeResponse>('profile/contact/activity/validate').then(mapToAurora);
  }

  /**
   * Validates if the user phone change request is authorized by fraud
   *
   * @returns The outcome of the request
   */
  async authorizePhoneChange(activity: number, callback: string) {
    const payload = {
      data: {
        facematch_callback_url: callback,
      },
    };
    return this.put<AuthorizePhoneChangeResponse>(`profile/contact/activity/${activity}/authorize`, payload).then(mapToAurora);
  }

  /**
   * Request an OTP
   *
   * @returns The outcome of the request
   */
  async sendOTP(data: SendOTPPayload) {
    const payload = {
      activity_id: data.activity,
      send_method_name: data.method,
      value: data.phone,
    };
    return this.post<SendNIPResponse>('profile/contact/otp/send', payload);
  }

  /**
   * Validate an OTP
   *
   * @returns The outcome of the request
   */
  async validateOTP(data: VerifyOTPPayload) {
    const payload = {
      activity_id: data.activity,
      channel: data.channel ?? 'web_2fa_change_phone',
      otp: data.nip,
      token_id: data.token,
      value: data.phone,
    };

    return this.post<SendNIPResponse>('profile/contact/otp/validate_new_phone', payload);
  }
}
